// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1862903b","453":"90f26b06","732":"bef41046","977":"3bd37372"}[chunkId] + ".chunk.js";
};